'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');
const SocketResponse=require('../../../../../../../dist-es6/client/dtos/socketResponse');
const BaseControllerBackedDirective=require('../../../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');

const ControllerDefaultBindings={
crewType:null,
availableRanks:[],
selectedRank:null,
isMinimized:!1};


const _bindingDefaultKeys=_.keys(ControllerDefaultBindings);

const _crewRanksByType={
F:['CA','FO'],
C:['PUR','SFS','FG1','GR1','GR2','CSA']};



_crewRanksByType['*']=_crewRanksByType.F.concat(_crewRanksByType.C);let

CrewRankSelectorController=
function CrewRankSelectorController($scope,$timeout){var _this=this;_classCallCheck(this,CrewRankSelectorController);
this._$scope=$scope;
this._$timeout=$timeout;

_.defaults(this,ControllerDefaultBindings);

this._$scope.$watch('controller.crewType',function(newCrewType){
_this.availableRanks=_crewRanksByType[newCrewType]||[];

if(_this.availableRanks.includes(_this.selectedRank)){
return;
}

_this.selectedRank=null;
});

this.availableRanks=this.availableRanks||[];
};let


CrewRankSelectorDirective=function(_BaseControllerBacked){_inherits(CrewRankSelectorDirective,_BaseControllerBacked);function CrewRankSelectorDirective(){_classCallCheck(this,CrewRankSelectorDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(CrewRankSelectorDirective,[{key:'templateUrl',get:function()
{return'/templates/features/emirates/emiratesDashboard/components/crewRankSelectorDirective/crewRankSelectorTemplate'}},{key:'objectBindings',get:function()

{return _bindingDefaultKeys}},{key:'$inject',get:function()

{return['$scope','$timeout']}},{key:'controller',get:function()

{return CrewRankSelectorController}}]);return CrewRankSelectorDirective}(BaseControllerBackedDirective);


module.exports=CrewRankSelectorDirective;
module.exports.CrewRanksByType=_.cloneDeep(_crewRanksByType);
//# sourceMappingURL=crewRankSelectorDirective.js.map
